// src/pages/Users/TechniquesQuizz/ProgressBar.jsx
import React from "react";

export default function ProgressBar({ value = 0 }) {
  return (
    <div className="w-full h-3 rounded-full bg-slate-200 dark:bg-slate-800 overflow-hidden mt-2">
      <div
        className="h-full rounded-full bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500 transition-[width] duration-300"
        style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </div>
  );
}
